import { combineReducers } from "redux";

import termoAceite from "./termoAceite/reducer";

export const identidade = combineReducers({
  termoAceite
});
